import { Input } from "@/components/ui/input";
import { Truck } from "lucide-react";

const TYPE_LABELS = {
  pickup_8ft: "Mahindra Pick Up (800 kg)",
  canter_14ft: "14 Feet Canter (3.5 MT)",
  closebody_20ft: "20 Feet Close Body (6 MT)",
  truck_20ft: "20 Feet Open Truck (6 MT)",
  closebody_22ft: "22 Feet Close Body (10 MT)",
  sxl_normal_32ft: "32 Feet SXL Normal (7 MT)",
  truck_32ft: "32 Feet Open Truck (8 MT)",
  sxl_32ft: "32 Feet SXL (9 MT)",
  sxl_hq_32ft: "32 Feet SXL HQ (7 MT — 10.5 ft tall)",
  mxl_32ft_15mt: "32 Feet MXL (15 MT)",
  mxl_32ft_18mt: "32 Feet MXL (18 MT)",
  trailer_40ft: "40 Feet Trailer (20 MT)",
  semi_bed_40ft: "40 Feet Semi Bed Trailer (35 MT — Heavy/ODC)",
  hydraulic_axle: "Hydraulic Axle (80 MT — Single package > 35 MT)",
};

export default function VehicleConfig({ vehicles, onChange }) {
  const update = (type, field, value) => {
    const numeric = ["length_cm", "width_cm", "height_cm", "max_payload_kg"];
    onChange(
      vehicles.map((v) =>
        v.type === type
          ? { ...v, [field]: numeric.includes(field) ? Number(value) || 0 : value }
          : v
      )
    );
  };

  const inputCls =
    "bg-transparent border-0 border-b border-slate-200 rounded-none focus:ring-0 focus:border-[#2563EB] mono text-sm h-8 px-1 text-right";
  const inputClsL =
    "bg-transparent border-0 border-b border-slate-200 rounded-none focus:ring-0 focus:border-[#2563EB] mono text-sm h-8 px-1";

  return (
    <div className="space-y-3 max-h-[720px] overflow-y-auto pr-1">
      {vehicles.map((v) => (
        <div
          key={v.type}
          className="bg-[#F8FAFC] border border-slate-200 p-4"
          data-testid={`vehicle-config-${v.type}`}
        >
          <div className="flex items-center gap-2 mb-3">
            <Truck className="w-4 h-4 text-[#2563EB]" />
            <div className="heading text-sm font-semibold uppercase tracking-wide">
              {TYPE_LABELS[v.type] || v.name || v.type}
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <label className="flex flex-col gap-1">
              <span className="overline">Length (cm)</span>
              <Input type="number" className={inputCls} value={v.length_cm}
                onChange={(e) => update(v.type, "length_cm", e.target.value)} />
            </label>
            <label className="flex flex-col gap-1">
              <span className="overline">Width (cm)</span>
              <Input type="number" className={inputCls} value={v.width_cm}
                onChange={(e) => update(v.type, "width_cm", e.target.value)} />
            </label>
            <label className="flex flex-col gap-1">
              <span className="overline">Height (cm)</span>
              <Input type="number" className={inputCls} value={v.height_cm}
                onChange={(e) => update(v.type, "height_cm", e.target.value)} />
            </label>
            <label className="flex flex-col gap-1">
              <span className="overline">Max Payload (kg)</span>
              <Input type="number" className={inputCls} value={v.max_payload_kg}
                onChange={(e) => update(v.type, "max_payload_kg", e.target.value)} />
            </label>
            <label className="flex flex-col gap-1 col-span-2">
              <span className="overline">Size Label (for Excel)</span>
              <Input
                type="text"
                data-testid={`size-label-${v.type}`}
                className={inputClsL}
                placeholder="e.g. 32x8x8"
                value={v.size_label || ""}
                onChange={(e) => update(v.type, "size_label", e.target.value)}
              />
            </label>
            {v.remarks && (
              <div className="col-span-2 mono text-[10px] text-[#64748B]">
                {v.remarks}
              </div>
            )}
          </div>
        </div>
      ))}
      <div className="mono text-[10px] text-[#64748B] leading-relaxed px-1">
        The Excel Trip Sheet keeps a blank Freight Charges column for you to fill after
        download. The algorithm auto-picks the smallest truck that fits your cargo.
      </div>
    </div>
  );
}
